module.exports = __webpack_public_path__ + "img/home-text.bbe465d5.png";